import React from 'react';
import { type Argument, cs } from '@bbkAdminUtils/css-utils';
import { TippyTooltip } from '@bbkAdminComponents/tooltips/tippy-tooltip';
import './styles/stat.scss';
import { DotIndicator } from '@bbkAdminComponents/indicators/dot';
import { StatLabel } from './stat-label';
import { StatValue } from './stat-value';
import { StatBadge } from './stat-badge';

export type Stat = {
  value?: React.ReactNode | number;
  valueClasses?: string;
  badgeValue?: string;
  badgeChange?: number;
  badgeBg?: number;
  badgeClasses?: Argument;
  indicatorColor?: React.ComponentProps<typeof DotIndicator>['dotColor'];
  reverseContent?: boolean;
  indicatorClasses?: Argument;
  indicatorOffset?: string;
  inlineContent?: boolean;
  label?: React.ReactNode | string;
  labelTooltip?: React.ReactNode | string;
  tooltip?: React.ReactNode;
};

const StatContainerStacked: React.FC<Stat> = (props) => {
  const {
    badgeBg = 0,
    badgeChange = 0,
    badgeClasses,
    badgeValue,
    indicatorClasses,
    indicatorColor,
    indicatorOffset,
    inlineContent,
    label,
    labelTooltip,
    reverseContent,
    tooltip,
    value = '--',
    valueClasses = 'green',
  } = props;

  function renderLabel() {
    return (
      label && (
        <div className="stat-container-bottom-row">
          <StatLabel label={label} toolTip={labelTooltip} />
        </div>
      )
    );
  }

  function renderBadge() {
    return (
      badgeValue && (
        <StatBadge
          value={badgeValue}
          change={badgeChange}
          bg={badgeBg}
          badgeClasses={badgeClasses}
        />
      )
    );
  }

  function renderIndicator() {
    return (
      indicatorColor && (
        <div className="stat-container-stacked-left-group">
          <DotIndicator
            dotColor={indicatorColor}
            className={
              indicatorClasses ||
              cs('small', {
                'small-value': indicatorOffset === 'smallLabel',
              })
            }
          />
        </div>
      )
    );
  }

  function renderValue() {
    const valueComponent = <StatValue value={value} classes={valueClasses} />;
    return tooltip ? (
      <TippyTooltip
        tippyOptions={{
          placement: 'left',
        }}
        content={tooltip}
      >
        {valueComponent}
      </TippyTooltip>
    ) : (
      valueComponent
    );
  }

  return (
    <div
      className={cs('stat-container-stacked', {
        'stat-container-stacked-inline': inlineContent,
      })}
    >
      {renderIndicator()}
      <div
        className={cs('stat-container-stacked-right-group', {
          'stat-container-reverse': reverseContent,
        })}
      >
        <div className="stat-container-top-row">
          {renderValue()}
          {renderBadge()}
        </div>
        {renderLabel()}
      </div>
    </div>
  );
};

export default StatContainerStacked;
